<div style="display: flex; align-items: center; align-content: center; width: 100%; height: 100%; background-color: var(--p-zinc-500);">
    <p-card>
        <div style="display: flex; flex-direction: column; gap: 1rem; align-items: center;">
            <h1 style="color: var(--p-primary-color);">Session Expired</h1>
            <p>Sorry, the page you requested does not exist.</p>
            <p-button (click)="redirectToLogin()">Redirect to Login</p-button>
        </div>
    </p-card>
</div>